import { message } from "antd";

interface IProps {
    duration: number;
    content: String;
    callback?: Function;
}

let isShowMessage = false;
const showCountdownMessage = (props: IProps) => {
    const { duration, content, callback } = props;
    if (isShowMessage) {
        return;
    }
    isShowMessage = true;
    let countdown = duration;
    message.config({ maxCount: 1 }); // 设置最大显示数量为1
    const countdownTimer = setInterval(() => {
        if (countdown === 0) {
            clearInterval(countdownTimer);
            isShowMessage = false;
            message.destroy();
            callback?.();
        } else {
            message.error(`${content}，${countdown}秒`);
            countdown -= 1;
        }
    }, 1000);
};

export default showCountdownMessage;
